import utils from 'helpers/utils';
import logger from 'helpers/logger';
import ServiceStore from 'stores/service.store';

const path = utils.servicePath(import.meta.url);

export class EntityPersonService extends ServiceStore {
  constructor (app, callbacks) {
    logger.trace(`Starting module at: services/${path}`);

    super(path, app, {
      key: 'personId',
      refreshEnabled: false,
      invalidateParent: true, // force invalidate entity when persons change
      invalidateFromParent: true,
      invalidateParentWithPriority: true
    }, callbacks);
  }
}
